import axios from '@axios'

const route = 'report/discount_report'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, filter) {
      return axios.post(route, filter)
    },

    exportExcel(context, filter) {
      return axios.post(`${route}/export_excel`, filter, { responseType: 'blob' })
    },
    exportPdf(context, filter) {
      return axios.post(`${route}/export_pdf`, filter, { responseType: 'blob' })
    },
    exportPdfPdv(context, filter) {
      return axios.post(`${route}/export_pdf_pdv`, filter, { responseType: 'blob' })
    },

  },
}
